import { axiosClient, axiosPHP } from "../api/axios";
export const postTransportEsc = async (data) => {
  try {
    const res = await axiosClient.post("/transport", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    });
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }  
};

export const putTransportEsc = async (data) => {
  try {
    const res = await axiosClient.post("/transport/renovacion", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    });
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }

};

export const dowloadFile = async () => {
  try {
    const res = await axiosClient.get("/transport/download-file");
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const postGenerarComprobante = async (data) => {
  try {
    const res = await axiosPHP.post("/derOficGeneraComprob.php", {
      data,
    });
    return res;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const mp = async (nro_comp) => {
  try {
    const res = await axiosPHP(
      "/derOficMercPagoComprob.php?tp_comprob=9&nr_comprob=" + nro_comp
    );
    window.open(res.data.url);
  } catch (error) {
    console.log(error);
    return error;
  }
};
